import { AnalyticsProvider as CarvanaAnalyticsProvider } from '@carvana/eventable-clickstream';
import trackPerformance from '@carvana/eventable-web-vitals';
import { useEffect } from 'react';
import type React from 'react';
import { applicationVersion, commonEnvironment } from '~/constants/environment';

type OwnProps = React.PropsWithChildren<{
  project: string;
  track: string;
}>;

function AnalyticsProvider({ children, project, track }: OwnProps) {
  useEffect(
    () =>
      trackPerformance({
        environment: commonEnvironment,
        project,
        track,
        payloadMetaAttributes: {
          application_version: applicationVersion
        }
      }),
    [project, track]
  );

  return (
    <CarvanaAnalyticsProvider
      environment={
        commonEnvironment === 'development' ? 'dev' : commonEnvironment
      }
      payloadMetaAttributes={{
        applicationVersion
      }}
      projectName={project}
      track={track}
    >
      {children}
    </CarvanaAnalyticsProvider>
  );
}

export default AnalyticsProvider;
